import React, { useState } from "react";
import { Badge, User } from "@ecologi/shared";
import { Wrapper } from "../Wrapper";
import { AchievementPopup } from "../Achievements";
import { Section, BackgroundVariant } from "../Section";
import { AchievementBadges } from "../Achievements/components/AchievementBadges";
import { Link } from "../Link";

type Props = {
  isOwnProfile: boolean;
  user: User;
};

export const ProfileAchievementsRow: React.FC<Props> = (props) => {
  const { user, isOwnProfile } = props;

  // Hold the state for the badge popup
  const [achievementPopupBadge, setAchievementPopupBadge] =
    useState<Badge | null>(null);

  let titleCopy = "";

  if (isOwnProfile && !user.isBusinessPlan) {
    titleCopy = "Keeping track of your personal climate contributions.";
  } else if (isOwnProfile && user.isBusinessPlan) {
    titleCopy = "Keeping track of your climate contributions.";
  } else if (!isOwnProfile && !user.isBusinessPlan) {
    titleCopy = "Keeping track of their personal climate contributions.";
  } else if (!isOwnProfile && user.isBusinessPlan) {
    titleCopy = "Keeping track of their climate contributions.";
  }

  return (
    <>
      <Section isExtraLarge backgroundVariant={BackgroundVariant.GREY}>
        <Section.HeadingWrapper marginBottomOverride="0">
          <Section.Title use="sectionTitle" as="h2">
            {isOwnProfile ? `Your badges` : `${user.fullName()}'s badges`}
          </Section.Title>
          <Section.Subtitle use="subtitle2" as="h3">
            {titleCopy}
          </Section.Subtitle>
          <Link href={`/${user.username}/badges`} title="badges link">
            <Section.Link use="standaloneLink" as="p">
              Go to badges section
            </Section.Link>
          </Link>
        </Section.HeadingWrapper>
        <Wrapper
          id="tour-achievements"
          isExtraLarge
          style={{ position: "relative" }}
        >
          <AchievementBadges
            user={user}
            isOwnProfile={isOwnProfile}
            setAchievementPopupBadge={setAchievementPopupBadge}
          />
        </Wrapper>
      </Section>
      {achievementPopupBadge && (
        <AchievementPopup
          badge={achievementPopupBadge}
          user={user}
          onClose={() => {
            setAchievementPopupBadge(null);
          }}
        />
      )}
    </>
  );
};
